import { dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import { locales, culture } from '../../../Helpers/dates';

export const APPOINTMENT_TIME = 30 * 60000; //30 hour
export const RECALL_TIME = 10 * 60000; //10 minutes

export const LOCALIZER = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export const FORMATS = {
  dateFormat: (date) => LOCALIZER.format(date, 'd', culture),
  dayFormat: (date) => LOCALIZER.format(date, 'dd EEE', culture),
  timeGutterFormat: (date) => LOCALIZER.format(date, 'HH:mm', culture),
  dayHeaderFormat: (date) => LOCALIZER.format(date, 'EEEE dd MMM', culture),
  weekdayFormat: (date) => LOCALIZER.format(date, 'EEEE', culture),
  monthHeaderFormat: (date) => LOCALIZER.format(date, 'MMMM yyyy', culture),
  agendaHeaderFormat: (range) =>
    `${LOCALIZER.format(
      range.start,
      'dd MMM yy',
      culture
    )} - ${LOCALIZER.format(range.end, 'dd MMM yy', culture)}`,
  dayRangeHeaderFormat: (range) =>
    `${LOCALIZER.format(range.start, 'dd MMMM', culture)} - ${LOCALIZER.format(
      range.end,
      'dd MMMM',
      culture
    )}`,
};

export const MIN_TIME = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate(),
  8
);

export const MAX_TIME = new Date(
  new Date().getFullYear(),
  new Date().getMonth(),
  new Date().getDate(),
  19
);

// Intentional, recognisable hues per event type (Google-Calendar style chips):
// blue for appointments, green for recalls. Falls back to the theme's hashing.
const EVENT_TYPE_COLORS = {
  Appuntamento: '#1D5B9D',
  Recall: '#7E57C2',
};

// Shared so the calendar chip and the details dialog use the same accent.
export const getEventBaseColor = (type, theme) =>
  EVENT_TYPE_COLORS[type] || theme.custom.stringToColor(type);

export function getEventStyle(type, isCanceled, theme) {
  const mode = theme.palette.mode;
  const isDark = mode === 'dark';

  if (isCanceled) {
    return {
      style: {
        backgroundColor: isDark ? 'rgba(154,160,166,0.18)' : '#f1f3f4',
        color: isDark ? '#bdc1c6' : '#80868b',
        borderLeft: '4px solid #9aa0a6',
        borderRadius: '6px',
        padding: '2px 8px',
        textDecoration: 'line-through',
        opacity: 0.85,
      },
    };
  }

  const baseColorHex = getEventBaseColor(type, theme);
  return {
    style: {
      // soft tinted background + readable text, driven by the theme helper
      ...theme.custom.bgAndColorStyle(baseColorHex, mode),
      // saturated accent bar reusing the --hue/--saturation it sets
      borderLeft: `4px solid hsl(var(--hue), var(--saturation), ${isDark ? 58 : 42}%)`,
      borderRadius: '6px',
      padding: '2px 8px',
      fontWeight: 500,
    },
  };
}
